import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect } from 'react';
import { useApolloErrorModal } from './hooks';
export var withApolloErrorHandler = function withApolloErrorHandler(name, handlerCreator) {
  return function (Component) {
    return function (props) {
      var context = useApolloErrorModal();
      useEffect(function () {
        context.addCustomHandler(name, handlerCreator(_objectSpread(_objectSpread({}, props), context)), props);
        return function () {
          context.removeCustomHandler(name, props);
        };
      }, [props]);
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, context));
    };
  };
};
export var withApolloErrorModal = function withApolloErrorModal(Component) {
  return function (_ref) {
    var props = _extends({}, _ref);

    var context = useApolloErrorModal();
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, context));
  };
};